import React from 'react';

const TOOL_TYPES = [
  {
    id: 'sweet_category',
    title: 'Sweet Category',
    description: 'For sweets items including categories and production based ordering.',
    accent: {
      bg: 'bg-red-50',
      text: 'text-red-500',
      border: 'border-red-200',
    },
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 9.5c0-1.4 1.1-2.5 2.5-2.5.9 0 1.7.4 2.2 1.1A2.98 2.98 0 0 1 14.6 7c1.6 0 2.9 1.3 2.9 2.9 0 .5-.1.9-.3 1.3 1.1.3 1.8 1.3 1.8 2.4 0 1.4-1.1 2.4-2.5 2.4H8.2A3.2 3.2 0 0 1 5 12.8c0-1.6 1.1-2.9 2.5-3.3Z" />
        <path d="M9.5 11.5c.7 1 1.5 1.6 2.5 1.6s1.8-.6 2.5-1.6" />
        <circle cx="9.5" cy="10.5" r=".5" fill="currentColor" stroke="none" />
        <circle cx="14.5" cy="10.5" r=".5" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
  {
    id: 'restaurant_item',
    title: 'Restaurant Item',
    description: 'For restaurant items and consumables. Outlet based ordering.',
    accent: {
      bg: 'bg-amber-50',
      text: 'text-amber-600',
      border: 'border-amber-200',
    },
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 10a6 6 0 0 1 12 0v.2c0 1.2-.3 2.3-.8 3.3L16 16H8l-1.2-2.5A7.3 7.3 0 0 1 6 10.2V10Z" />
        <path d="M8 16h8" />
        <path d="M9 18h6" />
        <path d="M12 4v2" />
      </svg>
    ),
  },
  {
    id: 'rm_pm',
    title: 'RM / PM',
    description: 'For Raw Material / Packaging Material & Purchase driven ordering.',
    accent: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-600',
      border: 'border-emerald-200',
    },
    icon: (
      <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" xmlns="http://www.w3.org/2000/svg">
        <path d="m12 3 7 4-7 4-7-4 7-4Z" />
        <path d="m5 7 7 4 7-4" />
        <path d="M5 7v8l7 4 7-4V7" />
        <path d="M12 11v8" />
      </svg>
    ),
  },
];

function StepSelectToolType({ wizardData, onChange }) {
  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900">Step 1: Select Tool Type</h3>
        <p className="mt-1 text-sm text-gray-500">
          Select the type of ordering tool you want to create.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
        {TOOL_TYPES.map((type) => {
          const selected = wizardData.toolType === type.id;
          return (
            <button
              key={type.id}
              type="button"
              onClick={() => onChange({ toolType: type.id })}
              className={`relative flex min-h-[255px] flex-col items-center rounded-2xl border bg-white px-6 py-7 text-center transition ${
                selected
                  ? 'border-brand border-2 shadow-sm ring-1 ring-brand/15'
                  : 'border-red-100 border-2 shadow-sm'
              }`}
            >
              <span
                className={`absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full border ${
                  selected ? 'border-brand border-2' : 'border-red-200 border-2'
                }`}
              >
                {selected ? <span className="h-2.5 w-2.5 rounded-full bg-brand" /> : null}
              </span>
              <div
                className={`flex h-20 w-20 items-center justify-center rounded-full ${type.accent.bg} ${type.accent.text} ${type.accent.border} border-2`}
              >
                {type.icon}
              </div>
              <div className="mt-5 flex flex-1 flex-col">
                <p className="text-[15px] font-semibold leading-4 text-gray-900">
                  Build To - Ordering Tool
                </p>
                <p className="mt-1 text-[1.35rem] font-bold leading-8 text-gray-900">
                  {type.title}
                </p>
                <p className="mt-4 text-sm leading-5 text-gray-500">{type.description}</p>
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex items-start gap-2 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3">
        <svg className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
        <p className="text-sm text-amber-800">
          <span className="font-semibold">Note:</span> You can create only one tool at a time. Each tool will be specific to the selected type.
        </p>
      </div>
    </div>
  );
}

export default StepSelectToolType;
